export const modalText = {
  confirmAction: "Подтвердите действие",
  unsavedChanges:
    "Внесенные изменения не будут сохранены. Вы действительно хотите продолжить?",
  continue: "Продолжить",
};
